import { ActionTree } from 'vuex';
import { Course, CourseState } from './state';
import RootState from '@/store/root_state';
import { MicroserviceEnum, query } from '@/helpers/westeros';
import {
  AllCoursesQueryResult,
  IsJacadCourseQueryResult,
  allCourses,
  isJacadCourse,
} from '@/store/graphql/queries/westerosArcaneumQueries';
import i18n from '@/i18n';
import { UpsertAdmissionMutationInput } from '@/store/graphql/mutations/westerosAdmissionsMutations';
import SentryClient from '@/helpers/sentry';

const actions: ActionTree<CourseState, RootState> = {
  async UPDATE_COURSE({ dispatch }, payload: { course: Course }) {
    const { course } = payload;

    const params: UpsertAdmissionMutationInput = { courseId: course.id };

    dispatch('UPSERT_ADMISSION', params);
  },
  async PULL_AVAILABLE_COURSES({ commit, state }): Promise<void> {
    const { availableCourses } = state;
    if (availableCourses.length > 0) return;

    const { data } = await query<AllCoursesQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allCourses,
      { isAvailable: true },
      true,
    );

    const courses: Course[] = data.allCourses.map(({ id, name, courseType, durationYears }) => ({
      id,
      name,
      type: courseType,
      duration: `${durationYears.toLocaleString()} ${i18n.tc('yearOfDuration', durationYears)}`,
    }));

    commit(
      'SET_AVAILABLE_COURSES',
      courses.sort(({ name: name1 = '' }, { name: name2 = '' }) => name1.localeCompare(name2)),
    );
  },
  async PULL_IS_JACAD_COURSE({ commit }): Promise<void> {
    try {
      const { data } = await query<IsJacadCourseQueryResult>(
        MicroserviceEnum.ARCANEUM,
        isJacadCourse,
      );

      commit('SET_IS_JACAD_COURSE', Boolean(data?.isJacadCourse));
    } catch (error) {
      commit('SET_IS_JACAD_COURSE', false);
      SentryClient.captureError(error as any);
    }
  },
};

export default actions;
